import { useState } from "react";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/customTable.scss";
import useColumnResize from "../../hooks/useColumnResize";

const NewAddressTable = ({ data, onSortChange }) => {
  const [sortConfig, setSortConfig] = useState({ key: "DateAdd", direction: "desc" });
  const navigate = useNavigate();
  const { getResizeProps } = useColumnResize();

  const items = Array.isArray(data) ? data : [];

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);
    onSortChange(newSortConfig);
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "↑" : "↓";
    }
    return "";
  };

  const handleRowClick = (item) => {
    navigate(`/administration/new-addresses/${item.id}`);
  };

  return (
    <div>
      <Table responsive striped bordered hover size="sm" className="custom-table">
        <thead>
          <tr>
            <th onClick={() => requestSort("Postcode")} {...getResizeProps()}>
              Kod {getSortArrow("Postcode")}
            </th>
            <th onClick={() => requestSort("Province")} {...getResizeProps()}>
              Województwo {getSortArrow("Province")}
            </th>
            <th onClick={() => requestSort("CityName")} {...getResizeProps()}>
              Miejscowość {getSortArrow("CityName")}
            </th>
            <th onClick={() => requestSort("Street")} {...getResizeProps()}>
              Ulica {getSortArrow("Street")}
            </th>
            <th onClick={() => requestSort("Number")} {...getResizeProps()}>
              Nr domu {getSortArrow("Number")}
            </th>
            <th onClick={() => requestSort("DateAdd")} {...getResizeProps()}>
              Data dodania {getSortArrow("DateAdd")}
            </th>
            <th {...getResizeProps()}>Użytkownik</th>
            <th {...getResizeProps()}>Status</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <tr
                key={`${item.id}-${index}`}
                onClick={() => handleRowClick(item)}
                style={{
                  cursor: "pointer",
                  transition: "background-color 0.2s ease",
                }}
                onMouseEnter={(e) => (e.target.closest("tr").style.backgroundColor = "#f8f9fa")}
                onMouseLeave={(e) => (e.target.closest("tr").style.backgroundColor = "")}
              >
                <td>{item.postcode}</td>
                <td>{item.province}</td>
                <td>{item.cityName}</td>
                <td>{item.street}</td>
                <td>{item.number}</td>
                <td>{item.dateAdd}</td>
                <td>{item.userLogin}</td>
                <td>
                  <span className={`badge bg-${getStatusBadgeColor(item.status)}`}>
                    {item.statusName}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">
                Brak danych
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

// Kolory badge'ow statusow nowych adresow
const getStatusBadgeColor = (status) => {
  switch (status) {
    case -2:
      return "danger";     // Odrzucony przez Algolytics
    case -1:
      return "secondary";  // Odrzucony przez DHL
    case 1:
      return "warning";    // W trakcie analizy
    case 2:
      return "info";       // Zgłoszony przez DHL
    case 3:
      return "success";    // Zaakceptowany przez Algolytics
    default:
      return "light";
  }
};

export default NewAddressTable;
